import { render, staticRenderFns } from "./debugCard.vue?vue&type=template&id=65093f34"
import script from "./debugCard.vue?vue&type=script&lang=ts"
export * from "./debugCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports